import Image from 'next/image';
import React from 'react';
import { FaTiktok, FaYoutube } from 'react-icons/fa';

/**
 * Social Media Component
 * Displays social media icons and links
 * 
 * @param {Array} socialIcons - Array of social media icon objects
 * @param {Boolean} isDarkMode - Dark mode state
 * @param {String} className - Additional CSS classes
 * @param {Boolean} isMobile - Whether this is for mobile layout
 */
const SocialMedia = ({ socialIcons, isDarkMode, className = '', isMobile = false }) => {
    if (!socialIcons || socialIcons.length === 0) return null;

    const socialIconClass = `inline-flex items-center justify-center w-10 h-10 rounded-lg transition-all duration-300 ease-in-out hover:bg-orange-500 hover:-translate-y-0.5 hover:border-orange-500 ${isDarkMode ? 'bg-gray-800 border border-gray-600' : 'bg-gray-700 border border-gray-500'}`;

    return (
        <div className={className}>
            <p style={{
                color: '#fff',
                fontSize: '16px',
                fontWeight: '600',
                marginBottom: isMobile ? '1rem' : '1.5rem',
                letterSpacing: '0.5px'
            }}>
                Follow Us
            </p>
            
            <div className={`d-flex gap-3 ${isMobile ? 'justify-content-center' : 'mb-3'}`}>
                {/* Dynamic Social Icons */}
                {socialIcons
                    .filter(icon => !icon.isHidden)
                    .map((icon, index) => (
                        <a
                            key={index}
                            href={icon.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={socialIconClass}
                        >
                            <Image
                                src={`https://images.hirego.co.uk/assets/Icons/${icon.type}.svg`}
                                width={20}
                                height={20}
                                alt={icon.type}
                                loading="lazy"
                                className="brightness-125 transition-all duration-300 ease-in-out hover:brightness-150"
                            />
                        </a>
                    ))}
                
                {/* Additional Social Icons - TikTok and YouTube */}
                <a
                    href="https://www.tiktok.com/@hiregouk"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Follow us on TikTok"
                    className={socialIconClass}
                >
                    <FaTiktok
                        size={20}
                        className="text-white transition-all duration-300 ease-in-out"
                    />
                </a>
                
                <a
                    href="https://www.youtube.com/@HireGOMinibusandCoaches"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Subscribe to our YouTube channel"
                    className={socialIconClass}
                >
                    <FaYoutube
                        size={20}
                        className="text-white transition-all duration-300 ease-in-out"
                    />
                </a>
            </div>
            
            {!isMobile && (
                <p style={{
                    color: '#b8b8b8',
                    fontSize: '13px',
                    lineHeight: '1.5'
                }}>
                    Stay connected with us for updates, news, and exclusive offers.
                </p>
            )}
        </div>
    );
};

export default SocialMedia;
